import React from 'react';
import { Row, Col } from 'react-bootstrap';

const Indicador = ({ titulo, valor, descricao, cor }) => (
  <div
    className="text-center py-2 px-2 h-100"
    style={{
      backgroundColor: cor,
      color: '#fff',
      borderRadius: '6px',
    }}
  >
    <div style={{ fontSize: '1.4rem', fontWeight: 700 }}>{valor}</div>
    <div style={{ fontSize: '0.7rem', fontWeight: 700 }}>{titulo}</div>
    <div style={{ fontSize: '0.7rem', opacity: 0.85 }}>{descricao}</div>
  </div>
);

const ContadoresPanel = ({ contadores, total }) => {
  if (!contadores) return null;
  return (
    <Row className="mt-3 row-cols-2 row-cols-md-5">
      <Col className="mb-2">
        <Indicador
          titulo="PSS"
          valor={contadores.escriturado_emitido || 0}
          descricao="Escriturado + Emitido"
          cor="#28a745"
        />
      </Col>
      <Col className="mb-2">
        <Indicador
          titulo="PSN"
          valor={contadores.escriturado_nao_emitido || 0}
          descricao="Escriturado, sem emissão"
          cor="#17a2b8"
        />
      </Col>
      <Col className="mb-2">
        <Indicador
          titulo="PNS"
          valor={contadores.nao_escriturado_emitido || 0}
          descricao="Não escriturado, com emissão"
          cor="#6c757d"
        />
      </Col>
      <Col className="mb-2">
        <Indicador
          titulo="PNN"
          valor={contadores.nao_escriturado_nao_emitido || 0}
          descricao="Não escriturado, sem emissão"
          cor="#ffc107"
        />
      </Col>
      <Col className="mb-2">
        <Indicador titulo="Ptot" valor={total || 0} descricao="Total listado" cor="#0747a6" />
      </Col>
    </Row>
  );
};

export default ContadoresPanel;
